module.exports = __webpack_public_path__ + "img/price-quote6.3ed04fe1.png";